import classNames from 'classnames';
import type * as React from 'react';
import Spinner from '../Spinner';

type Props = React.HTMLAttributes<HTMLDivElement>;

export default function Loader({ className, ...other }: Props) {
    const props = {
        ...other,
        className: classNames(className, 'react-loader'),
    };

    return (
        <div {...props}>
            <Spinner />
        </div>
    );
}
